













    import Vue from 'Vue';
    import Vuex from 'Vuex';

    export default Vue.extend({
        name: 'attribution-panel',
        data(): { renderedAttribution: string[]} {
            return { renderedAttribution: []  };
        },
        components: {
        },
        created(): void {
        },
        beforeDestroy(): void {

        },
        computed: {
            myAttributions(): string[] {
                return this.$store.getters['map/attribution'];                
            },
            haveAttributions(): boolean {
                const attr: string[] = this.$store.getters['map/attribution'];
                return attr && attr.length > 0;                
            }
        },
        methods: {
        }
    });
